<script>
export default {
  props: {
    line: {
      type: Number,
      default: 1,
      required: false,
    },
    text: {
      type: [String, Number, null],
      required: true,
      default: null,
    },
  },
};
</script>
<template>
  <div :class="`line-clamp-${line}`" v-bind="$attrs" v-on="$listeners">
    {{ text ?? '...' }}
  </div>
</template>
